"use client";

import { c as _c } from "react/compiler-runtime";
import { BottomSheet } from "@opensea/ui-kit";
import { useSnapshot } from "valtio";
import { FlowActions, FlowState } from "../../stores/flowStore";
import { AcceptOfferFlow } from "./AcceptOfferFlow/AcceptOfferFlow";
import { BottomSheetErrorBoundary } from "./BottomSheetErrorBoundary";
import { CancelAllOrdersFlow } from "./CancelAllOrdersFlow/CancelAllOrdersFlow";
import { CancelOrderFlow } from "./CancelOrderFlow/CancelOrderFlow";
import { CheckoutFlow } from "./CheckoutFlow/CheckoutFlow";
import { CollectionSweepFlow } from "./CollectionSweepFlow/CollectionSweepFlow";
import { CreateCollectionOfferFlow } from "./CreateCollectionOfferFlow/CreateCollectionOfferFlow";
import { CreateOfferFlow } from "./CreateOfferFlow/CreateOfferFlow";
import { DropPublishFlow } from "./DropPublishFlow/DropPublishFlow";
import { ListingFlow } from "./ListingFlow/ListingFlow";
import { MintFlow } from "./MintFlow/MintFlow";
import { TokenClaimFlow } from "./TokenClaimFlow/TokenClaimFlow";
import { TransferFlow } from "./TransferFlow/TransferFlow";
export const BottomSheetFlows = () => {
  const $ = _c(7);
  const {
    flow
  } = useSnapshot(FlowState);
  const mutableFlow = flow;
  const handleOpenChange = _temp;
  let t0;
  if ($[0] !== mutableFlow) {
    t0 = isBottomSheetFlow(mutableFlow);
    $[0] = mutableFlow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isBottomSheetFlowActive = t0;
  let t1;
  if ($[2] !== mutableFlow) {
    t1 = <BottomSheetErrorBoundary><FlowContent flow={mutableFlow} /></BottomSheetErrorBoundary>;
    $[2] = mutableFlow;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== isBottomSheetFlowActive || $[5] !== t1) {
    t2 = <BottomSheet content={t1} onOpenChange={handleOpenChange} open={isBottomSheetFlowActive} />;
    $[4] = isBottomSheetFlowActive;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const FlowContent = t0 => {
  const $ = _c(24);
  const {
    flow
  } = t0;
  switch (flow?.type) {
    case "checkout":
      {
        let t1;
        if ($[0] !== flow) {
          t1 = <CheckoutFlow {...flow} />;
          $[0] = flow;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "token-claim":
      {
        let t1;
        if ($[2] !== flow) {
          t1 = <TokenClaimFlow {...flow} />;
          $[2] = flow;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "collection-sweep":
      {
        let t1;
        if ($[4] !== flow) {
          t1 = <CollectionSweepFlow {...flow} />;
          $[4] = flow;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "accept-offer":
      {
        let t1;
        if ($[6] !== flow) {
          t1 = <AcceptOfferFlow {...flow} />;
          $[6] = flow;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "cancel-order":
      {
        let t1;
        if ($[8] !== flow) {
          t1 = <CancelOrderFlow {...flow} />;
          $[8] = flow;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "listing":
      {
        let t1;
        if ($[10] !== flow) {
          t1 = <ListingFlow {...flow} />;
          $[10] = flow;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "create-offer":
      {
        let t1;
        if ($[12] !== flow) {
          t1 = <CreateOfferFlow {...flow} />;
          $[12] = flow;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case "create-collection-offer":
      {
        let t1;
        if ($[14] !== flow) {
          t1 = <CreateCollectionOfferFlow {...flow} />;
          $[14] = flow;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case "transfer":
      {
        let t1;
        if ($[16] !== flow) {
          t1 = <TransferFlow {...flow} />;
          $[16] = flow;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case "cancel-all-orders":
      {
        let t1;
        if ($[18] !== flow) {
          t1 = <CancelAllOrdersFlow {...flow} />;
          $[18] = flow;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case "mint":
      {
        let t1;
        if ($[20] !== flow) {
          t1 = <MintFlow {...flow} />;
          $[20] = flow;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        return t1;
      }
    case "drop-publish":
      {
        let t1;
        if ($[22] !== flow) {
          t1 = <DropPublishFlow {...flow} />;
          $[22] = flow;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};
const BOTTOM_SHEET_FLOWS = new Set(["checkout", "token-claim", "collection-sweep", "accept-offer", "cancel-order", "transfer", "listing", "create-offer", "create-collection-offer", "cancel-all-orders", "mint", "drop-publish"]);
function isBottomSheetFlow(flow) {
  return !!flow && BOTTOM_SHEET_FLOWS.has(flow.type);
}
function _temp(open) {
  if (!open) {
    FlowActions.endFlow();
  }
}